import { Button } from '@mui/material'
import React, { useContext } from 'react'
import { SiteLink } from '../../app-types'
import { siteLinkToProps } from '../../utils/siteLinkToProps'
import { useForwardedHref } from '../../utils/appUrl'
import { ArrowButton } from '../ArrowButton'
import { SectionContext } from '../Section/Context'
import { resolveAutoButtonColor } from './resolveAutoColor'

export const LinkButton: React.FunctionComponent<
  SiteLink & {
    params?: string
  }
> = ({ params, ...props }) => {
  let { variant = 'contained' } = props
  const transformedProps = siteLinkToProps(props, params)
  const hasHref = !!transformedProps && 'href' in transformedProps
  const forwardedHref = useForwardedHref(
    hasHref ? (transformedProps as { href: string }).href : undefined,
  )
  const { backgroundColor } = useContext(SectionContext)

  let Component: typeof Button | typeof ArrowButton = Button
  if (variant === 'auto') {
    variant = 'contained'
  } else if (variant === 'text') {
    Component = ArrowButton
  }

  const color = resolveAutoButtonColor({
    backgroundColor,
    variant,
    explicit: props.color,
  })

  return (
    <Component
      variant={variant}
      color={color}
      {...transformedProps}
      {...(hasHref ? { href: forwardedHref } : {})}
    >
      {props.label}
    </Component>
  )
}
